import React, { useEffect, useState } from "react";
import { getSortedCollection } from "sprint-common-web";

import { GetLanguageSpecificationsListResponse } from "../../../../common/api/orders-api/language-specification/responses/GetLanguageSpecificationsListResponse";
import { useLanguageSpecificationApi } from "../../../../common/api/orders-api/language-specification/useLanguageSpecificationApi";
import {
    LanguageSpecificationListingItem,
    mapToLanguageSpecificationListingItem
} from "../LanguageSpecificationListingItem";
import { LanguageSpecificationListingFilters } from "../useLanguageSpecificationListingFilters";
import { LanguageSpecificationListingContext } from "./LanguageSpecificationListingContext";

export const LanguageSpecificationListingProvider: React.FC = ({ children }) => {
    const { getLanguageSpecificationsList } = useLanguageSpecificationApi();

    const [languageSpecificationItems, setLanguageSpecificationItems] = useState<LanguageSpecificationListingItem[]>(
        []
    );
    const [totalItems, setTotalItems] = useState<number>(0);
    const [isLoading, setIsLoading] = useState<boolean>(true);

    useEffect(() => {
        setIsLoading(true);

        getLanguageSpecificationsList()
            .then((response: GetLanguageSpecificationsListResponse) => {
                const languageSpecifications = response.items.map(mapToLanguageSpecificationListingItem);

                setLanguageSpecificationItems(languageSpecifications);
                setTotalItems(languageSpecifications.length);
            })
            .finally(() => {
                setIsLoading(false);
            });
    }, []);

    const load = (filters: LanguageSpecificationListingFilters): void => {
        const sortedItems = getSortedCollection(languageSpecificationItems, filters.sortBy, filters.sortOrder);

        setTotalItems(sortedItems.length);
        setLanguageSpecificationItems(sortedItems);
    };

    const addLanguageSpecificationItem = (item: LanguageSpecificationListingItem) => {
        setLanguageSpecificationItems((prevState) => [...prevState, item]);
    };

    return (
        <LanguageSpecificationListingContext.Provider
            value={{ languageSpecificationItems, isLoading, add: addLanguageSpecificationItem, totalItems, load }}
        >
            {children}
        </LanguageSpecificationListingContext.Provider>
    );
};
